import React, { useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
// import { Navbar, SideBar } from "./Layouts/MainPage";
// import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import SettingsSidebar, { SettingsSidebarItem } from "../../Layouts/MainPage/SettigsSideBar";
import { Navbar } from "../../Layouts/MainPage";
import Maintanance from "../../Components/Icons/Maintanance";
import Shipping from "../../Components/Icons/Shipping";
// import Store from "../../Components/Icons/Store";
import Task from "../../Components/Icons/Task";
import Payments from "../../Components/Icons/Payments";
import Sales from "../../Components/Icons/Sales";
import Procurement from "../../Components/Icons/Procurement";
import Marketing from "../../Components/Icons/Marketing";
import Products from "../../Components/Icons/Products";
import Staff from "../../Components/Icons/Staff";
import UserRole from "../../Components/Icons/UserRole";
import Role from "../../Components/Icons/Role";
import BellIcon from "../../Components/Icons/BellIcon";
import { GetAccess } from "../../Components/Utils/roles";
import Email from "../../Components/Icons/Email";
import Template from "../../Components/Icons/Template";
import PdfTemplate from "../../Components/Icons/PdfTemplate";
import Signatutre from "../../Components/Icons/Signatutre";
import Reference from "../../Components/Icons/Reference";
import CurrencyIcon from "../../Components/Icons/Currency";
import StatusIcon from "../../Components/Icons/Status";
import PermissionIcon from "../../Components/Icons/Status";
import ProductIcon from "../../Components/Icons/ProfileIcon";
import CompanyInfoIcon from "../../Components/Icons/Company";
import Notes from "../../Components/Icons/Notes";
import Project from "../../Components/Icons/Project";
import Contacts from "../../Components/Icons/Contacts";
import Bidding from "../../Components/Icons/Bidding";
import Members from "../../Components/Icons/Member";
 import {
  Building2,
  Gavel,
  PackageSearch,
  Truck,
  FolderKanban,
  ShoppingCart,
  Users,
  BookUser,
  Store,
  Send,
  ShieldCheck,
  UserCog,
  UserCircle,
  Bell,
  Mail,
  Link2,
  DollarSign,
  PenTool,
  Shield,
  ClipboardCheck,
  Server,
  FilePlus,
  FileText as FileTextIcon,
  StickyNote,
} from "lucide-react";

const MainSettings = () => {
  const location = useLocation();
const {officeId} =useParams()
  const {t} = useTranslation();


const navItem = [
  {
    icon: <Building2 size={16} />,
    title: "Company Info",
    link: `/settings/${officeId}`,
    hasAccess: "company_info_view",
  },
  {
    icon: <Gavel size={16} />,
    title: "Bidding",
    link: `/settings/${officeId}/bidding`,
    hasAccess: "bids_view",
  },
   {
    icon: <FolderKanban size={16} />,
    title: "Project",
    link: `/settings/${officeId}/project`,
    hasAccess: "project_view",
  },
  {
    icon: <ShoppingCart size={16} />,
    title: "Products",
    link: `/settings/${officeId}/products`,
    hasAccess: "product_view",
  },
  {
    icon: <Truck size={16} />,
    title: "Procurement",
    link: `/settings/${officeId}/procurement`,
    hasAccess: "procurement_view",
  },
 
  {
    icon: <PackageSearch size={16} />,
    title: "Sales",
    link: `/settings/${officeId}/sales`,
    hasAccess: "sales_view",
  },
  {
    icon: <Users size={16} />,
    title: "Employee",
    link: `/settings/${officeId}/employee`,
    hasAccess: "employees_view",
  },
  {
    icon: <BookUser size={16} />,
    title: "Contract",
    link: `/settings/${officeId}/contract`,
    hasAccess: "contract_view",
  },
  {
    icon: <Store size={16} />,
    title: "Store",
    link: `/settings/${officeId}/store`,
    hasAccess: "store_view",
  },
  {
    icon: <Send size={16} />,
    title: "Shipping",
    link: `/settings/${officeId}/shipping`,
    hasAccess: "shipping_view",
  },
  {
    icon: <ShieldCheck size={16} />,
    title: "Role",
    link: `/settings/${officeId}/role`,
    hasAccess: "role_view",
  },
  {
    icon: <UserCog size={16} />,
    title: "User",
    link: `/settings/${officeId}/user`,
    hasAccess: "user_view",
  },
  {
    icon: <UserCircle size={16} />,
    title: "User Role",
    link: `/settings/${officeId}/user-role`,
    hasAccess: "user_role_view",
  },
  {
    icon: <Bell size={16} />,
    title: "Notifications",
    link: `/settings/${officeId}/notifications`,
    hasAccess: "notification_view",
  },
  {
    icon: <Mail size={16} />,
    title: "Holidays",
    link: `/settings/${officeId}/user-holiday`,
    hasAccess: "user_holiday_view",
  },
  {
    icon: <Link2 size={16} />,
    title: "Reference",
    link: `/settings/${officeId}/reffrence`,
    hasAccess: "reference_view",
  },
  {
    icon: <DollarSign size={16} />,
    title: "Currency And Vat",
    link: `/settings/${officeId}/currency-vat`,
    hasAccess: "reference_view",
  },
  {
    icon: <PenTool size={16} />,
    title: "Seal And Signature",
    link: `/settings/${officeId}/sealandsignature`,
    hasAccess: "reference_view",
  },
  {
    icon: <Shield size={16} />,
    title: "Approval Permission",
    link: `/settings/${officeId}/statuspermission`,
    hasAccess: "reference_view",
  },
  {
    icon: <ClipboardCheck size={16} />,
    title: "Approval Status",
    link: `/settings/${officeId}/newApproval`,
    hasAccess: "reference_view",
  },
  {
    icon: <Server size={16} />,
    title: "Email Server",
    link: `/settings/${officeId}/emailserverdetails`,
    hasAccess: "reference_view",
  },
  {
    icon: <FilePlus size={16} />,
    title: "Template",
    link: `/settings/${officeId}/template`,
    hasAccess: "reference_view",
  },
  {
    icon: <FileTextIcon size={16} />,
    title: "PDF Template",
    link: `/settings/${officeId}/pdfTemplate`,
    hasAccess: "reference_view",
  },
  {
    icon: <StickyNote size={16} />,
    title: "PDF Notes",
    link: `/settings/${officeId}/notes`,
    hasAccess: "reference_view",
  },
];




  function isActiveFun(x){
    let actualPath = location.pathname
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         linkPath = y
      }
    }else{
      linkPath = x?.link;
    }
    if(actualPath == linkPath) {
      return true;
    }else{
      return false;
    }
  }

  return (
     <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
      <SettingsSidebar>
        {navItem &&
          navItem.map((item) => {
            return (
              <>
              {
                GetAccess(item?.hasAccess) && (
                  <SettingsSidebarItem
                  icon={item?.icon}
                  text={t(item?.title)}
                  hasSubMenu={item?.hasSubMenu}
                  subItem={item?.subMenu}
                  link={item?.link}
                  active={isActiveFun(item)}
                  //  alert = "test"
                />
                )
              }
              </>
            );
          })}
      </SettingsSidebar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
        {/* <div className=" w-full h-7 ">
          <p className=' font-semibold text-center text-s text-slate-400'>
            <a
             href="https://numota.in"
             target="_blank"
            >
              &#169;  numota
            </a>
            </p>
        </div> */}
      </div>
    </div>
  );
};

export default MainSettings;
